import * as Yup from "yup";

export class ContraparteSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      razaoSocial,
      nomeFantasia,
      cnpj,
    } = recordShape;

    const createFormShape = {
      razaoSocial,
      nomeFantasia,
      cnpj,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      razaoSocial,
      nomeFantasia,
      cnpj,
    } = recordShape;

    const updateFormShape = {
      razaoSocial,
      nomeFantasia,
      cnpj,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  razaoSocial: Yup
    .string()
    .required("Campo é obrigatório"),
  nomeFantasia: Yup
    .string()
    .required("Campo é obrigatório"),
  cnpj: Yup
    .string()
    .required("CNPJ é obrigatório"),
};
